// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3hMhD26diXj74hvnQBxRrs {\n  max-width: 600px;\n  margin: 8px auto 0;\n\n  padding-bottom: 2em;\n}\n\n._2CFTaBuJxeRGkLuYyiJJvu {\n  margin: 30px 0 0;\n}\n\n._1qedz4w5ZlvxfTPGBqVLYj {\n  font-size: 38px;\n  line-height: 1.2;\n  color: #30b5c7;\n  font-weight: 400;\n  text-align: center;\n}\n\n._35CdmIpbzqBlz9kS0cM9FS {\n  font-size: 34px;\n  color: #30b5c7;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n._2fhj0jMq8i3FZuxt7elLNm {\n  font-size: 25px;\n  color: #30b5c7;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n._3ru7JQJn3AtL88f19tLr4G {\n  font-size: 18px;\n  line-height: 1.42;\n  margin: 0 auto 40px;\n}\n\n._1RV4SYZtUDs9wjyicK-WwD {\n  margin: 11px auto 10px;\n  line-height: 1.3;\n}", ""]);
// Exports
exports.locals = {
	"container": "_3hMhD26diXj74hvnQBxRrs",
	"heading": "_2CFTaBuJxeRGkLuYyiJJvu",
	"h1": "_1qedz4w5ZlvxfTPGBqVLYj",
	"h2": "_35CdmIpbzqBlz9kS0cM9FS",
	"h3": "_2fhj0jMq8i3FZuxt7elLNm",
	"largePara": "_3ru7JQJn3AtL88f19tLr4G",
	"emailLink": "_1RV4SYZtUDs9wjyicK-WwD"
};
module.exports = exports;
